import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef
} from "@angular/core";
import { ModalService } from "../../../utilities/modal/modal.service";
import { TwoFactorAuthService } from "../two-factor-auth.service";

@Component({
  selector: "deny-modal",
  templateUrl: "./deny-modal.component.html",
  styleUrls: ["./deny-modal.component.scss"]
})
export class DenyModalComponent implements OnInit {
  @Input() modalId: string;
  @Input() contract: any;
  @Input() denyModalTitle: string;
  @Input() denyModalMsg: string;
  @ViewChild("errorDiv") errorDiv: ElementRef;
  constructor(
    private modalService: ModalService,
    private twoFactorAuthService: TwoFactorAuthService
  ) {}
  ngOnInit() {
  }

  close(event?: any) {
    this.contract = null;
    this.twoFactorAuthService.error = [];
    this.twoFactorAuthService.serviceFail = null;
    this.modalService.close(this.modalId);
    this.twoFactorAuthService.loading = true;
  }

  continueToNavigate() {
    this.twoFactorAuthService.loading = true;
    this.close(event);
    window.location.href = 
      "/iam/two-step-verification?context=DASHBOARD";
      // "/wps/myportal/isc/two-step-verification?context=DASHBOARD";
  }
}
